/**
 * Allows only numeric input (digits, optional dot).
 */
export const allowOnlyNumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const allowedKeys = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
  ];

  // Allow control keys and numbers + dot
  if (
    !(
      allowedKeys.includes(e.key) ||
      /^[0-9.]$/.test(e.key)
    )
  ) {
    e.preventDefault();
  }
};